
<template>
    <div class="edit-game"
         :style="`height: ${newHeight}px !important`"
         @click="handleMouseEnterOpen"
    >
        <div
            v-if="isShowWarn"
            class="warn"
            :class="{hide: warnHide}"
        >
            <p class="word">{{warnInfo || defaultWarnInfo}}</p>
        </div>
        <div class="set-default"
            v-if="isShowSetGameConfig"
        >
            <el-button
                type="default"
                size="small"
                @click="handlerSetGameConfig"
            >设为默认配置</el-button>
        </div>
        <div class="move">
            <div class="move-box"
               @mousedown="newIsMove = true">
                <p class="move-warn">
                   <span class="iconfont icon-shangxiayidong"></span>
                    <span class="word">拖拽移动</span>
                </p>
            </div>
        <el-tabs v-model="activeName" @tab-click.native.stop="handleClick">
            <el-tab-pane label="游戏场景" name="scenes">
            </el-tab-pane>
            <el-tab-pane label="游戏题目" name="question">
            </el-tab-pane>
        </el-tabs>
        </div>
        <div class="tab-content" v-if="$store.state.editGameConfig">
            <div
                v-if="activeName==='scenes' && $store.state.editGameConfig.scenesData"
                class="game-scene"
            >
                <ScenesBox
                    :form.sync="$store.state.editGameConfig.scenesData"
                />
                <ForegroundBox />
                <BackgroundBox />
            </div>
            <Question
                ref="question"
                :expandeds.sync="expandeds"
                v-show="activeName==='question'"
            />
        </div>
        <div class="empty-box" v-else>
            <span>暂无数据</span>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import ScenesBox from './components/scenes'
    import ForegroundBox from './components/foreground'
    import BackgroundBox from './components/background'
    import Question from './components/question'
    export default {
        name: "EditGame",
        components: {
            ScenesBox,
            ForegroundBox,
            BackgroundBox,
            Question
        },
        computed: {
            ...mapState(['menusData', 'menusDataIds']),
            isShowSetGameConfig(){
                let state = false
                try {
                    state = this.$store.getters.isPlat && this.menusDataIds[this.menusData.lessonSelected]?.config?.form_id_common>-1
                } catch (e) {
                    console.log('判断是否有设置默认配置权限失败==>', e)
                }
                return state
            }
        },
        props: {
            isMove: Boolean,
            height: [String, Number],
        },
        watch: {
          isMove (vl) {this.newIsMove = vl},
          newIsMove (vl) {this.$emit('update:isMove', vl)},
          height (vl) {this.newHeight = vl},
          newHeight (vl) {this.$emit('update:height', vl)}
        },
        mounted(){
            // 监听鼠标移动事件
            this.$nextTick(()=>{
                this.moving()
                window.onresize = ()=>{
                    this.newHeight = this.newHeight + 1
                }
                // 监听游戏编辑器提示语框
                $eventBus.$on('showWarn', this.showWarnInfo)
            })
        },
        data(){
            return {
                isShowWarn: false,
                warnHide: false, // 提示语是否隐藏
                warnInfo: '', // 提示语
                defaultWarnInfo: '游戏形式无法支持本项操作，请尝试其他方式进行操作。', // 默认提示语

                newHeight: this.height, // 移动高度
                newIsMove: this.isMove,
                activeName: 'question',
                gameConfig: {
                    "scenesData": {
                        "categoryId": 0,
                        "config": null
                    },
                    "question": {
                        "header": {
                            "title": "新增题目数",
                            "isHide": false,
                            "event": {
                                "type": "???",
                                "webData": null
                            }
                        },
                        "questionArray": {
                            "0": {
                                "title": "标题",
                                "operationArray": {
                                    "0": {
                                        "type": "Btns",
                                        "name": "音频",
                                        "url": "",
                                        "buttonArray": {
                                            "0": {
                                                "name": "替换",
                                                "isHide": true
                                            },
                                            "1": {
                                                "name": "播放",
                                                "type": "play"
                                            }
                                        },
                                        "buttonType": "audio"
                                    },
                                    "1": {
                                        "type": "Input",
                                        "name": "答题时间",
                                        "value": 10,
                                        "min": 0,
                                        "max": 60,
                                        "step": 1
                                    },
                                    "2": {
                                        "type": "InputNumber",
                                        "name": "答题时间",
                                        "value": 10,
                                        "min": 0,
                                        "max": 60,
                                        "step": 1
                                    },
                                    "3": {
                                        "type": "Switch",
                                        "name": "作为答案",
                                        "value": true
                                    }
                                },
                                "childrens": {
                                    "0": {
                                        "title": "标题",
                                        "operationArray": {
                                            "0": {
                                                "type": "Btns",
                                                "name": "音频",
                                                "url": "",
                                                "buttonArray": {
                                                    "0": {
                                                        "name": "替换",
                                                        "event": {
                                                            "type": "???",
                                                            "webData": null
                                                        }
                                                    },
                                                    "1": {
                                                        "name": "播放",
                                                        "event": {
                                                            "type": "???",
                                                            "webData": null
                                                        }
                                                    },
                                                    "2": {
                                                        "name": "普通按钮",
                                                        "event": {
                                                            "type": "???",
                                                            "webData": null
                                                        }
                                                    }
                                                },
                                                "buttonType": "audio"
                                            },
                                            "1": {
                                                "type": "Input",
                                                "name": "答题时间",
                                                "value": 10,
                                                "min": 0,
                                                "max": 60,
                                                "step": 1
                                            },
                                            "2": {
                                                "type": "InputNumber",
                                                "name": "答题时间",
                                                "value": 10,
                                                "min": 0,
                                                "max": 60,
                                                "step": 1
                                            },
                                            "3": {
                                                "type": "Switch",
                                                "name": "作为答案",
                                                "value": true
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                // 游戏编辑区展开id集
                expandeds: null,
            }
        },
        methods: {
            // 设置游戏默认配置
            handlerSetGameConfig(){
                // 1.获取游戏最新配置
                // 2.备份一份游戏通用配置
                // 3.修改游戏通用配置
                this.$toCocosMessage({type: 'SaveConfig', value: {flag: 'setGameConfig'}})
            },
            // 显示提示语 并在n毫秒后消失
            showWarnInfo({text, during}){
                this.warnInfo = ''
                this.isShowWarn = true
                if(text) this.warnInfo = text

                const fn = setTimeout(()=>{
                    this.warnHide = true
                    const fn1 = setTimeout(()=>{
                        this.warnHide = false
                        this.isShowWarn = false
                        clearTimeout(fn1)
                    }, 500)
                    clearTimeout(fn)
                }, (during && during - 500) || 1500)
            },
            // 取消所有高亮
            clearHighLight(){
                this.$refs.question && this.$refs.question.clearHighLight()
            },
            moving(){
                let div = document.getElementById('app')
                // 获取屏幕可视高度
                // let curDiv = document.querySelector('.edit-game')
                div.addEventListener('mousemove', (e) => {
                    let screenH = document.body.clientHeight
                    if (this.newIsMove) {
                        // console.log('移动22==>', e.pageY)
                        let resH = screenH - e.pageY
                        this.newHeight = resH > 20 ? resH : 20

                        // 拖动立即关闭文字编辑
                        console.log('文字编辑关闭==>')
                        this.$toWebMessage({type: 'EditFont',value:{isShow:false, top: 0, left: 0, config: {b:true,isText:true}}})

                    }
                })
                // div.addEventListener('mouseup', () => {
                //    this.newIsMove = false
                // })
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            handleMouseEnterOpen(){
                this.$store.state.menusKeyBoard=false;//当前是可操作焦点
            },
        },
        destroyed(){
            this.expandeds = null
            $eventBus.$off('showWarn')
        }
    }
</script>
<style>
    .edit-game .el-tabs__header{
        margin: 0px !important;
    }
</style>
<style lang="scss" scoped>
.edit-game{
    width: calc(100% - 8px);
    padding: 0px 4px;
    height: 310px;
    background-color: white;
    position: absolute;
    bottom: 0px;
    display: flex;
    flex-direction: column;
    user-select: none;

    .warn{
        position: absolute;
        top: 30px;
        left: 0px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 10;
        transition: all .2s linear;
        opacity: 1;

        &.hide{
            opacity: 0;
        }

        .word{
            max-width: 400px;
            padding: 10px 20px;
            background-color: rgba(0,0,0,.5);
            border-radius: 4px;
            color: white;
            font-size: 14px;
        }
    }
    .set-default{
        position: absolute;
        top: 5px;
        right: 120px;
        font-size:14px;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:20px;
        z-index: 100;
    }
    .move{
        position: relative;

        .move-box {
            position: absolute;
            left: 246px;
            top: 0px;
            z-index: 10;
            width: calc(100% - 246px);
            height: 100%;
            cursor: ns-resize;

            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;

            .move-warn{
                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:20px;

                .icon-shangxiayidong{
                    font-size: 15px;
                }
                .word{
                    margin-left: 7px;
                    margin-right: 13px;
                }
            }
        }
    }

    .tab-content{
        width: 100%;
        height: calc(100% - 30px);
        overflow-y: auto;

        .game-scene{
            display: flex;
            flex-direction: row;
        }
    }

    .empty-box{
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
        color: #BDBEC7;
        font-size: 14px;
    }
}
</style>